import Big from "big.js";
import { UseFormReturn } from "react-hook-form";
import {
  denpyoshubetcuKbn,
  shireUchiwakeKbn,
  tenyuryokuKbn,
} from "services/codes";
import { B000170Get, B000200Get } from "..";
import { catchRestError, RestClient } from "../RestClient";

// 加算符号のプラス
const kasanfugoPlus: number = 1;

export type B050010CreateRequest = {
  shireYmd: string;
  shireCd: string;
  shainCd: string;
  chohaKbn: string;
  // 明細
  shireMei: B050010CreateMeiRequest[];
} & Partial<{
  shireNm: string;
  bumonCd: string;
  eigyoCd: string;
  bikoCd: string;
  biko: string;
}>;

export type B050010CreateMeiRequest = {
  shiregyoNo: string;
  uchiwakeKbn: string;
  shohinCd: string;
  sokoCd: string;
} & Partial<{
  shohinNm: string;
  shiresu: string;
  juchugyoNo: string;
  tenyuryokuKbn: string;
  shiretanka: string;
  shireKin: string;
  meisaibikoCd: string;
  meisaibiko: string;
}>;

// 仕入入力登録処理メソッド
export const B050010Create = (methods: UseFormReturn, rows: any) => {
  const fields = methods.getValues();

  // マッピング
  // 明細
  const meiData: B050010CreateMeiRequest[] = rows.map((row: any) => {
    return row;
  });

  // ヘッダー
  const data: B050010CreateRequest = {
    shireYmd: fields.shireYmd,
    shireCd: fields.shireCd,
    shainCd: fields.shainCd,
    chohaKbn: fields.chohaKbn.value,
    shireNm: fields.shireNm,
    bumonCd: fields.bumonCd,
    eigyoCd: fields.eigyoCd,
    bikoCd: fields.bikoCd,
    biko: fields.biko,
    shireMei: [...meiData],
  };

  return RestClient.post("b050010/create", data);
};

export type B050010UpdateRequest = {
  shiredenpyoNo: string;
  shireYmd: string;
  shireCd: string;
  shainCd: string;
  chohaKbn: string;
  version: string;
  // 明細
  shireMei: B050010UpdateMeiRequest[];
} & Partial<{
  shireNm: string;
  bumonCd: string;
  eigyoCd: string;
  bikoCd: string;
  biko: string;
}>;

export type B050010UpdateMeiRequest = {
  shiregyoNo: string;
  uchiwakeKbn: string;
  shohinCd: string;
  sokoCd: string;
} & Partial<{
  shohinNm: string;
  shiresu: string;
  juchugyoNo: string;
  tenyuryokuKbn: string;
  shiretanka: string;
  shireKin: string;
  meisaibikoCd: string;
  meisaibiko: string;
}>;

// 仕入入力更新処理メソッド
export const B050010Update = (methods: UseFormReturn, rows: any) => {
  const fields = methods.getValues();

  // マッピング
  // 明細
  const meiData: B050010UpdateMeiRequest[] = rows.map((row: any) => {
    return row;
  });

  // ヘッダー
  const data: B050010UpdateRequest = {
    shiredenpyoNo: fields.shiredenpyoNo,
    shireYmd: fields.shireYmd,
    shireCd: fields.shireCd,
    shainCd: fields.shainCd,
    chohaKbn: fields.chohaKbn.value,
    version: fields.version,
    shireNm: fields.shireNm,
    bumonCd: fields.bumonCd,
    eigyoCd: fields.eigyoCd,
    bikoCd: fields.bikoCd,
    biko: fields.biko,
    shireMei: [...meiData],
  };

  return RestClient.put("b050010/update", data);
};

export type B050010DeleteRequest = Partial<{
  shiredenpyoNo: string;
}>;

// 仕入入力削除メソッド
export const B050010Delete = (props: B050010DeleteRequest) => {
  return RestClient.delete("b050010/delete", { data: props });
};

//消費税取得処理リクエスト
export type B050010GetZeiRitsuRequest = {
  kijunYmd: string;
};

//消費税取得処理レスポンス
export type B050010GetZeiRitsuResponse = {
  zeiRitsu: string;
};

export const B050010GetZeiRitsu = (props: B050010GetZeiRitsuRequest) => {
  return RestClient.get<B050010GetZeiRitsuResponse>("b010010/get/shohizei", {
    params: props,
  });
};

//消費税取得処理メソッド
export const B050010ZeiRitsu = async (methods: UseFormReturn) => {
  const fields = methods.getValues();
  if (!fields.shireYmd) {
    return;
  }
  await B050010GetZeiRitsu({ kijunYmd: fields.shireYmd }).then((response) => {
    methods.setValue("zeiRitsu", response.data.zeiRitsu ?? "");
  });
};

export type B050010GetShohinRequest = {
  shohinCd: string;
  shireYmd: string;
};

export type B050010GetShohinResponse = {
  shohinNm: string;
  shohinshokuchiKbn: string;
  shiretanka: string;
};

export const B050010GetShohin = (props: B050010GetShohinRequest) => {
  return RestClient.get<B050010GetShohinResponse>("b050011/get/shohin", {
    params: props,
  });
};

// 商品関連項目表示メソッド
export const B050010Shohin = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    meiMethods.setValue("shohinNm", "");
    meiMethods.setValue("shohinshokuchiKbn", "");
    meiMethods.setValue("tenyuryokuKbn", "");
    meiMethods.setValue("basetanka", "");
    meiMethods.setValue("shiretanka", "");
    meiMethods.setValue("sokoCd", "");
    meiMethods.setValue("sokoNm", "");
    return;
  }
  // 商品名表示
  await B050010GetShohin({
    shohinCd: meiFields.shohinCd,
    shireYmd: fields.shireYmd,
  })
    .then((response) => {
      meiMethods.setValue("shohinNm", response.data.shohinNm ?? "");
      meiMethods.setValue(
        "shohinshokuchiKbn",
        response.data.shohinshokuchiKbn ?? ""
      );

      // uchiwakeKbn が 2 以外の場合
      if (meiFields.uchiwakeKbn.value !== shireUchiwakeKbn.nebiki) {
        // basetanka(shiretanka と同じ値) , shiretanka を設定する。
        meiMethods.setValue(
          "basetanka",
          response.data.shiretanka.toString() ?? ""
        );
        meiMethods.setValue(
          "shiretanka",
          response.data.shiretanka.toString() ?? ""
        );

        // tenyuryokuKbn に 0(なし)を設定する。
        meiMethods.setValue("tenyuryokuKbn", tenyuryokuKbn.none);

        // 仕入金額再計算
        if (meiFields.shiresu === "") {
          meiMethods.setValue("shireKin", "");
        } else {
          // shireKin に設定する。shiresu × shiretanka
          const calcShireKin: Big = new Big(meiFields.shiresu!)
            .times(new Big(response.data.shiretanka))
            .round(0, Big.roundDown);
          meiMethods.setValue("shireKin", calcShireKin.toString());
        }
      }
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("shohinNm", "");
      meiMethods.setValue("shohinshokuchiKbn", "");
      meiMethods.setValue("tenyuryokuKbn", "");
      meiMethods.setValue("basetanka", "");
      meiMethods.setValue("shiretanka", "");
    });
};

// 商品コード変更メソッド
export const B050010HandleChangeShohinCd = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 変更されていない場合は切替しない。
  if (!meiMethods.getFieldState("shohinCd").isDirty) {
    return;
  }

  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    meiMethods.setValue("shohinNm", "");
    meiMethods.setValue("shohinshokuchiKbn", "");
    meiMethods.setValue("tenyuryokuKbn", "");
    meiMethods.setValue("basetanka", "");
    meiMethods.setValue("shiretanka", "");
    meiMethods.setValue("shireKin", "");
    return;
  }
  // 商品名表示
  await B000200Get({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("shohinNm", response.data.shohinNm ?? "");
      meiMethods.setValue("shohinshokuchiKbn", response.data.shokuchiKbn ?? "");
      // 値を保持
      meiMethods.unregister("shohinCd", { keepValue: true });

      // 商品関連項目設定処理
      B050010Shohin(methods, meiMethods, navigate, setMsg);
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("shohinNm", "");
      meiMethods.setValue("shohinshokuchiKbn", "");
      meiMethods.setValue("basetanka", "");
      meiMethods.setValue("shiretanka", "");
      meiMethods.setValue("shireKin", "");
    });
};

// 単価取得メソッド
export const B050010Tanka = async (
  methods: UseFormReturn,
  shohinCd: string,
  rows: any,
  navigate: Function,
  setMsg: Function,
  setRows: Function
) => {
  const fields = methods.getValues();
  // 商品名表示
  await B050010GetShohin({
    shohinCd: shohinCd,
    shireYmd: fields.shireYmd,
  })
    .then((response) => {
      for (const row of rows) {
        // 商品コードが一致しない場合、何もしない
        if (shohinCd !== row.shohinCd) continue;
        // 単価が編集されている場合、何もしない
        if (row.tenyuryokuKbn === tenyuryokuKbn.exists) continue;

        // basetanka , shiretanka に設定する。
        row.basetanka = response.data.shiretanka.toString();
        row.shiretanka = response.data.shiretanka.toString();

        const calcShireKin: Big = new Big(row.shiresu!)
          .times(new Big(row.shiretanka!))
          .round(0, Big.roundDown);
        row.shireKin = calcShireKin.toString();
      }
      // 明細に反映
      setRows([...rows]);
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      catchRestError(reason, navigate, setMsg);
    });
};

export type B050010GetShainRequest = {
  shainCd: string;
};

export type B050010GetShainResponse = {
  shainNm: string;
  bumonCd: string;
  bumonNm: string;
  eigyoCd: string;
};

export const B050010GetShain = (props: B050010GetShainRequest) => {
  return RestClient.get<B050010GetShainResponse>("b050011/get/shain", {
    params: props,
  });
};

// 仕入先表示
export const B050010Shire = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  if (!fields.shireCd) {
    methods.setValue("shireNm", "");
    methods.setValue("shainCd", "");
    methods.setValue("shainNm", "");
    methods.setValue("bumonCd", "");
    methods.setValue("bumonNm", "");
    methods.setValue("eigyoCd", "");
    methods.setValue("shireshokuchiKbn", "");
    return;
  }
  await B000170Get({ shireCd: fields.shireCd })
    .then((response) => {
      methods.setValue("shireNm", response.data.shireNmr ?? "");
      methods.setValue("shainCd", response.data.shainCd ?? "");
      methods.setValue("shireshokuchiKbn", response.data.shokuchiKbn ?? "");
      // 社員関連項目取得
      B050010Shain(methods, navigate, setMsg);
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shireNm", "");
      methods.setValue("shainCd", "");
      methods.setValue("shainNm", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("eigyoCd", "");
      methods.setValue("shireshokuchiKbn", "");
    });
};

// 社員関連項目取得処理メソッド
export const B050010Shain = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  if (!fields.shainCd) {
    methods.setValue("shainNm", "");
    methods.setValue("bumonCd", "");
    methods.setValue("bumonNm", "");
    methods.setValue("eigyoCd", "");
    return;
  }
  await B050010GetShain({ shainCd: fields.shainCd })
    .then((response) => {
      methods.setValue("shainNm", response.data.shainNm ?? "");
      methods.setValue("bumonCd", response.data.bumonCd ?? "");
      methods.setValue("bumonNm", response.data.bumonNm ?? "");
      methods.setValue("eigyoCd", response.data.eigyoCd ?? "");
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shainNm", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("eigyoCd", "");
    });
};

// 内訳区分取得処理リクエスト
export type B050010GetUchiwakeKbnRequest = {
  denpyoshubetsuKbn: number;
};

// 内訳区分取得処理レスポンス
export type B050010GetUchiwakeKbnResponse = {
  uchiwakeKbn: string;
  uchiwakeNmr: string;
  kasanfugo: number;
};

export const B050010GetUchiwakeKbn = (props: B050010GetUchiwakeKbnRequest) => {
  return RestClient.get<B050010GetUchiwakeKbnResponse[]>(
    "b020010/find/uchiwakeKbnList",
    {
      params: props,
    }
  );
};

// 内訳区分取得処理メソッド
export const B050010UchiwakeKbn = async (
  setKasanfugoPlusList: Function,
  navigate: Function,
  setMsg: Function
) => {
  await B050010GetUchiwakeKbn({ denpyoshubetsuKbn: denpyoshubetcuKbn.shiire })
    .then((response) => {
      // 加算符号がプラスの設定
      setKasanfugoPlusList(
        response.data
          .filter(function (source: B050010GetUchiwakeKbnResponse) {
            return source.kasanfugo === kasanfugoPlus;
          })
          .map((value) => {
            return value.uchiwakeKbn;
          })
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
    });
};

// 可能数取得処理リクエスト
export type B050010GetKanosuRequest = {
  sokoCd: string;
  shohinCd: string;
};

// 可能数取得処理レスポンス
export type B050010GetKanosuResponse = {
  kanosu: string;
};

export const B050010GetKanosu = (props: B050010GetKanosuRequest) => {
  return RestClient.get<B050010GetKanosuResponse>("b050010/get/kanosu", {
    params: props,
  });
};

// 可能数取得処理メソッド
export const B050010Kanosu = async (
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const meiFields = meiMethods.getValues();
  if (!meiFields.sokoCd || !meiFields.shohinCd) {
    meiFields.setValue("kanosu", "");
    return;
  }

  await B050010GetKanosu({
    sokoCd: meiFields.sokoCd,
    shohinCd: meiFields.shohinCd,
  })
    .then((response) => {
      meiMethods.setValue("kanosu", response.data.kanosu ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("kanosu", "");
    });
};
